import { render, staticRenderFns } from "./WorkInProgressView.vue?vue&type=template&id=0381ee6a&scoped=true&lang=pug"
import script from "./WorkInProgressView.vue?vue&type=script&lang=js"
export * from "./WorkInProgressView.vue?vue&type=script&lang=js"
import style0 from "./WorkInProgressView.vue?vue&type=style&index=0&id=0381ee6a&prod&lang=scss&scoped=true"
import style1 from "./WorkInProgressView.vue?vue&type=style&index=1&id=0381ee6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381ee6a",
  null
  
)

export default component.exports